module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "breadcrumb"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('li', {
      staticClass: "breadcrumb-item"
    }, [(_vm.isLast(index)) ? _c('span', {
      staticClass: "active"
    }, [_vm._v(_vm._s(_vm.showName(item)))]) : _c('router-link', {
      attrs: {
        "to": item.path
      }
    }, [_vm._v(_vm._s(_vm.showName(item)))])], 1)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05f708fc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Breadcrumb.vue
// module id = 729
// module chunks = 8